var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H42C44.2091 0 46 1.79086 46 4V28C46 30.2091 44.2091 32 42 32H4C1.79086 32 0 30.2091 0 28V4Z",
    fill: "#1F72CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12722 11.3333L3.88574 20.9956H8.96339L9.59287 19.4551H11.0317L11.6612 20.9956H17.2503V19.8198L17.7483 20.9956H20.6394L21.1374 19.795V20.9956H32.7611L34.1745 19.4951L35.498 20.9956L41.4682 21.0081L37.2133 16.1915L41.4682 11.3333H35.5906L34.2147 12.8062L32.9329 11.3333H20.2878L19.202 13.8272L18.0907 11.3333H13.0237V12.4691L12.46 11.3333H8.12722ZM9.10972 12.7054H11.5848L14.3982 19.2575V12.7054H17.1095L19.2825 17.4032L21.2852 12.7054H23.983V19.6387H22.3415L22.3281 14.2058L19.9348 19.6387H18.4664L16.0598 14.2058V19.6387H12.6827L12.0425 18.0844H8.58358L7.94468 19.6374H6.1353L9.10972 12.7054ZM32.1598 12.7054H25.4849V19.6346H32.0564L34.1745 17.3382L36.2161 19.6346H38.3502L35.2483 16.1901L38.3502 12.7054H36.3087L34.2013 14.9755L32.1598 12.7054ZM10.3138 13.8785L9.17419 16.6474H11.452L10.3138 13.8785ZM27.1332 15.4066V14.1409V14.1397H31.2982L33.1155 16.1639L31.2176 18.1991H27.1332V16.8173H30.7747V15.4066H27.1332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/Amex.3ce813a1f017438af4a5e12f0c426b3e.svg";
export { ForwardRef as ReactComponent };